import { motion, AnimatePresence } from 'framer-motion';
import { LIFESTYLE_REEL } from './data';
import { useAutoAdvance } from './useAutoAdvance';

export const LifestyleReel = () => {
  const index = useAutoAdvance(LIFESTYLE_REEL.length, 4500);
  const slide = LIFESTYLE_REEL[index];

  return (
    <section className="relative bg-black" data-testid="lifestyle-reel">
      <div className="relative w-full h-[70vh] md:h-screen overflow-hidden">
        <AnimatePresence mode="sync">
          <motion.img
            key={index}
            src={slide.src}
            alt={slide.label}
            initial={{ opacity: 0, scale: 1.08 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 1.04 }}
            transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
            className="absolute inset-0 w-full h-full object-cover"
          />
        </AnimatePresence>
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-black/20" />
        <div className="absolute bottom-10 left-8 md:bottom-16 md:left-16">
          <p className="text-[#c8bfa8]/70 text-[10px] md:text-xs tracking-[0.4em] uppercase mb-3">The Lifestyle</p>
          <AnimatePresence mode="wait">
            <motion.p
              key={index}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -6 }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className="text-white text-2xl md:text-4xl font-light tracking-[0.15em] uppercase"
              data-testid="lifestyle-reel-label"
            >
              {slide.label}
            </motion.p>
          </AnimatePresence>
        </div>
        <div className="absolute top-8 right-8 md:top-12 md:right-16 flex gap-2">
          {LIFESTYLE_REEL.map((s, i) => (
            <span key={s.label} className={`h-px w-8 md:w-12 transition-colors duration-700 ${i === index ? 'bg-[#c8bfa8]' : 'bg-white/25'}`} />
          ))}
        </div>
      </div>
    </section>
  );
};
